import AppContext from '@aurora/shared-client/components/context/AppContext/AppContext';
import { EndUserPages } from '@aurora/shared-types/pages/enums';
import dynamic from 'next/dynamic';
import React, { useContext } from 'react';
import useBoardDetails from '@aurora/shared-client/components/community/Board/useBoardDetails';
import BasePage from '../../../components/page/BasePage/BasePage';
import useNodePageSeoProps from '../../../components/useNodePageSeoProps';

const BoardActionMenu = dynamic(
  () => import('../../../components/community/Board/BoardActionMenu/BoardActionMenu')
);
const NodeSubscriptionAction = dynamic(
  () => import('../../../components/nodes/NodeSubscriptionAction/NodeSubscriptionAction')
);

/**
 * Idea Board Page
 *
 * @author Be.Abhijith
 */
const IdeaBoardPage: React.FC<React.PropsWithChildren> = () => {
  const {
    queryResult: { data: boardDetails },
    boardData,
    loading: boardInfoLoading
  } = useBoardDetails(false, {
    useCanManageIdea: true
  });
  const nextSeoProps = useNodePageSeoProps(boardData);
  const { contextNode } = useContext(AppContext);

  if (boardInfoLoading) {
    return null;
  }

  const { board } = boardDetails;

  /**
   * Renders the Board action menu.
   */
  function renderBoardActionMenu(): React.ReactElement {
    return <BoardActionMenu board={board} />;
  }

  /**
   * Renders the node subscription action.
   */
  function renderBoardSubscriptionAction(): React.ReactElement {
    return <NodeSubscriptionAction node={contextNode} />;
  }

  return (
    <BasePage
      pageId={EndUserPages.IdeaBoardPage}
      nextSeoProps={nextSeoProps}
      breadcrumbActionComponents={[renderBoardSubscriptionAction, renderBoardActionMenu]}
    />
  );
};
export default IdeaBoardPage;
